import type { UseFormReturn } from "react-hook-form";
import type { JobPostFormInput } from "@/components/Forms/JobPostForm/types";
import JobApplicantCountEstimateBlock from "./JobApplicantCountEstimateBlock";
import { useJobApplicantCountEstimate } from "./useJobApplicantCountEstimate";

export default function JobApplicantCountEstimateFormSection({ form }: { form: UseFormReturn<JobPostFormInput> }) {
  const { estimate, criteriaComplete } = useJobApplicantCountEstimate(form);
  const serviceLevel = form.watch("serviceLevel");
  const stage = form.watch("stage");
  const applyVia = form.watch("applyVia");

  return (
    <JobApplicantCountEstimateBlock
      estimate={estimate}
      criteriaComplete={criteriaComplete}
      serviceLevel={serviceLevel}
      stage={stage}
      applyVia={applyVia}
    />
  );
}
